"use client";
import React, { use, useEffect, useMemo, useState } from "react";
import Image from "next/image";
import styles from "../../styles/index.pc.module.scss";

import Switch, { SwitchCardType } from "app/(new-pages)/components/Switch";
import Loading from "app/components/loading";
import { fetchHomePage, fetchJobs } from "../../services";
import { Tabs, Empty, Dropdown, Tooltip } from "antd";
import CardList from "./CardList/index.pc";
import { getCookie } from "helpers/cookies";
import classNames from "classnames";
import { AvatarVip } from "../../images/svg";
import LinkMoreClient from "./LinkMore.pc.client";
import { addEventTag } from "helpers/utilities";
import EmptyImage from "../../images/noData.png";
import { getCountryKey, getServerLanguageCode } from "helpers/country";
import JobPrefForHomeModal from "components/RemotePrefModal/JobPrefForHomeModal";
import { postNotification } from "bossjob-remote/dist/clientStorage";

const googleTagTabs = [
  "hp_job_for_you_classification_click",
  "hp_popular_jobs_classification_click_"
];

interface JobsHiringPcProps {
  langKey: string;
  pageData: any;
  dictionary?: any;
  cardTypeInPersonal: any;
  device_udid?: string;
}

const JobsHiringPc = (props: JobsHiringPcProps) => {
  const langKey = props?.langKey;
  const pageData = props?.pageData || {};
  // let jobsData = pageData.jobs || {};
  const lang = props?.dictionary || {};
  const sessionid = getCookie("sessionid");
  const cardTypeInPersonal = props?.cardTypeInPersonal;
  const countryKey = getCountryKey();
  const [showPrefModal, setShowPrefModal] = useState(false);
  const [currentTabId, setCurrentTabId] = useState(null);
  const [jobsData, setJobsData] = useState<any>(() => pageData.jobs || {});
  const [activePref, setActivePref] = useState<{
    id: number;
    job_title: string;
    work_arrangement: string;
    is_remote_preference: boolean;
  }>(() => {
    const _jobsData = pageData.jobs || {};
    return {
      id: _jobsData?.preference_id,
      job_title: _jobsData?.right_highlight_text,
      work_arrangement: _jobsData?.pref_work_arrangement,
      is_remote_preference: _jobsData?.is_remote_preference
    };
  });
  const [openPref, setOpenPref] = useState(false);
  const jobPreferences = useMemo(() => jobsData?.pref_info_list || [], [jobsData]);
  const { title } = jobsData || {};
  const { tabs, more_text } = jobsData || {};
  const [loading, setLoading] = useState(false);
  // 兼容处理登陆情况
  const [type, setType] = useState(jobsData?.tabs[0].main_function_id || 0);
  const [jobs, setJobs] = useState(
    () =>
      jobsData?.tabs?.find((e) => e?.main_function_id == type)?.jobs || jobsData?.tabs?.[0]?.jobs
  );

  const [cardType, setCardType] = useState<SwitchCardType>(props?.cardTypeInPersonal || "column");

  useEffect(() => {
    if (cardTypeInPersonal) {
      setCardType(cardTypeInPersonal);
    }
  }, [cardTypeInPersonal]);

  useEffect(() => {
    if (sessionid) {
      const _jobsData = pageData.jobs || {};
      setJobsData(_jobsData);
      setActivePref({
        id: _jobsData?.preference_id,
        job_title: _jobsData?.right_highlight_text,
        work_arrangement: _jobsData?.pref_work_arrangement,
        is_remote_preference: _jobsData?.is_remote_preference
      });
      setCurrentTabId(2); // login default tab: recommend
      setJobs(_jobsData?.tabs?.[0]?.jobs);
      setType(_jobsData?.tabs[0].main_function_id || 0);
    }
  }, [pageData, sessionid]);

  // console.log("jobsData::", { jobs, jobsData, lang, currentTabId });

  // useEffect(() => {
  //   if (sessionid && type) {
  //     onChange(type);
  //   }
  // }, [sessionid, type]);

  const items = tabs.map((e, index) => {
    return {
      key: e.main_function_id || index,
      label: e.name,
      seo_value: e.seo_value
    };
  });

  const handleGoogleTag = (key) => {
    const tabName = items?.find((e) => e.key == key);
    const gtagEventName = sessionid ? googleTagTabs[0] : googleTagTabs[1];

    if (!sessionid) {
      addEventTag(gtagEventName + tabName?.seo_value);
    } else {
      addEventTag(gtagEventName);
    }
  };

  const onChange = (key: string) => {
    handleGoogleTag(key);

    setType(Number(key));

    if (sessionid) {
      setLoading(true);
      const tabName = items?.find((e) => e.key == key);
      const tab_id = tabName?.seo_value == "recommended" ? 2 : 1;
      setCurrentTabId(tab_id);
      const params = {
        job_preferences_id: activePref?.id,
        is_remote: activePref?.is_remote_preference,
        recommend_tab_id: tab_id
      };
      fetchJobs(params)
        .then((res) => {
          setJobs(res?.data?.data);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(true);
      setCurrentTabId(key);
      fetchJobs({ main_job_function_id: key })
        .then((res) => {
          setJobs(res?.data?.data);
        })
        .finally(() => setLoading(false));
    }
  };

  // const handleJobPref = () => {
  //   if (sessionid) {
  //     addEventTag("hp_job_for_you_pre_click");
  //     window.open(`/${langKey}/manage-profile?tab=job-preferences`, "_blank");
  //   }
  // };
  const fetchHomePageData = async (preference_id) => {
    try {
      setLoading(true);
      const serverLangCode = getServerLanguageCode(lang);
      const homeResult = await fetchHomePage({
        lang: serverLangCode,
        device_udid: props?.device_udid,
        preference_id: preference_id
      });
      const pageData = homeResult?.data?.data || {};
      setJobsData(pageData?.jobs || {});
      const _jobsData = pageData.jobs || {};
      setActivePref({
        id: _jobsData?.preference_id,
        job_title: _jobsData?.right_highlight_text,
        work_arrangement: _jobsData?.pref_work_arrangement,
        is_remote_preference: _jobsData?.is_remote_preference
      });
      setType(0);
      setJobs(_jobsData?.tabs?.[0]?.jobs || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleJobPrefModal = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setShowPrefModal(true);
    setOpenPref(false);
  };

  const changeJobPref = (item) => {
    // console.log("item", item, currentTabId);
    setActivePref(item);
    setOpenPref(false);

    setLoading(true);
    const params = {
      job_preferences_id: item.id,
      is_remote: item?.is_remote_preference,
      recommend_tab_id: currentTabId
    };
    fetchJobs(params)
      .then((res) => {
        setActivePref(item);
        setJobs(res?.data?.data);
      })
      .finally(() => setLoading(false));
  };

  const login = (e) => {
    if (!sessionid && e.target.id === "home-login-btn-bzp5zrma") {
      postNotification("SHOW_LOGIN_MODAL");
      return;
    }
  };

  useEffect(() => {
    window.addEventListener("click", login, true);
    return window.removeEventListener("click", login);
  }, []);

  const { highlight_text, text } = jobsData || {};

  const newText = text.replace(highlight_text, `<span>${highlight_text}</span>`);
  const right_text = jobsData?.right_text || "";
  const right_highlight_text = jobsData?.right_highlight_text || "";

  let rightNewText = right_text.replace(right_highlight_text, ``);
  if (right_text?.includes("：")) {
    rightNewText = right_text.replace("：" + right_highlight_text, ``);
  }

  if (right_text?.includes(": ")) {
    rightNewText = right_text.replace(": " + right_highlight_text, ``);
  }

  const improveText = text.replace(
    highlight_text,
    `<span id="home-login-btn-bzp5zrma">${highlight_text}</span>`
  );

  // console.log("jobsData", jobsData);

  const emptyCustom = () => {
    if (!sessionid) {
      return (
        <div className={styles.emptyContent}>
          <Empty />
        </div>
      );
    }

    return (
      <div className={styles.emptyContent}>
        <div className={styles.emptyMain}>
          <Image width={90} height={90} src={EmptyImage.src} alt='' />

          <p className={styles.emptyMainTitle}>
            {lang?.myJobs?.noMatchingJobs || "No matching jobs found (for now...)"}
          </p>

          {jobPreferences?.length < 6 ? (
            <p className={styles.emptyMainDesc}>
              {lang?.myJobs?.noMatchingJobsDescription ||
                "but don’t worry, there are still many ways to discover great opportunities."}
            </p>
          ) : (
            <p className={styles.emptyMainDesc}>
              {lang?.myJobs?.noMatchingMaxJobsDescription ||
                "but don’t worry, you can still switch your job preference or try these ways to discover great opportunities"}
            </p>
          )}

          <div className={styles.emptyMainList}>
            {jobPreferences?.length < 6 ? (
              <div className={styles.emptyMainListItem}>
                <a href='javascript:void(0);' onClick={handleJobPrefModal}>
                  {lang?.myJobs?.updatePreference || "Update Preference"} <ArrowIcon />
                </a>
              </div>
            ) : null}

            <div className={styles.emptyMainListItem}>
              <a href={`/${langKey}/jobs-hiring/job-search`} target='_blank'>
                {lang?.myJobs?.browseAllJobs || "Browse All Jobs"} <ArrowIcon />
              </a>
            </div>
            <div className={styles.emptyMainListItem}>
              <a
                href={"/" + langKey + (countryKey === "jp" ? "/talent" : "/talents")}
                target='_blank'
              >
                {lang?.myJobs?.downloadApp || "Download the App"} <ArrowIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const prefItemsRender = () => {
    return (
      <div className={styles.dropdownContainer}>
        {(jobsData?.pref_info_list || []).map((item, index) => {
          return (
            <div
              onClick={() => changeJobPref(item)}
              className={classNames(
                styles.dropdownItem,
                item.id === activePref?.id && styles.dropdownItemChecked
              )}
              key={item.id}
            >
              <div className={styles.dropdownItemMain}>
                <span className={styles.dropdownItemTitle}>{item.job_title}</span>
                <span className={styles.dropdownItemTag}>({item.work_arrangement})</span>
              </div>
              {item.id === activePref?.id && (
                <span className={styles.dropdownItemIcon}>
                  <CheckIcon />
                </span>
              )}
            </div>
          );
        })}
        {jobPreferences?.length < 6 ? (
          <div className={styles.dropdownAdd} onClick={handleJobPrefModal}>
            <AddIcon /> {jobsData?.pref_add_new_text || "Add New"}
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <>
      <section className={styles.jobsHiring}>
        <div className={styles.jobsHiringBox}>
          <div className={styles.jobsH2TitleWrap}>
            <h2>{title}</h2>
            <div>
              <Switch cardType={cardType} setCardType={setCardType} />
            </div>
          </div>
          {sessionid ? (
            <p className={styles.improve} dangerouslySetInnerHTML={{ __html: newText }}></p>
          ) : (
            <p className={styles.improveText} dangerouslySetInnerHTML={{ __html: improveText }}></p>
          )}

          <div className={styles.jobTabWrap}>
            <Tabs defaultActiveKey={type} items={items} onChange={onChange} />
            {sessionid && (
              <div className={styles.jobTab}>
                <div
                  className={classNames([
                    styles.jobTabAvatarWrapper,
                    jobsData?.is_vip ? styles.jobTabAvatarVip : ""
                  ])}
                >
                  <Image
                    className={styles.jobTabAvatar}
                    src={jobsData?.user_avatar}
                    width={28}
                    height={28}
                    alt=''
                  ></Image>
                  {jobsData?.is_vip && <AvatarVip />}
                </div>
                <span className={styles.jobTabText}>{rightNewText}:</span>

                {jobPreferences?.length > 0 ? (
                  <>
                    <Tooltip
                      placement='top'
                      title={activePref?.job_title}
                      getPopupContainer={(node) => node.parentElement}
                    >
                      <span className={styles.jobTabTitle}>{activePref?.job_title}</span>
                    </Tooltip>
                    {/* <span className={styles.jobTabTitle}>{activePref?.job_title}</span> */}
                    <span className={styles.jobTabTag}>({activePref?.work_arrangement})</span>
                    <Dropdown
                      overlayStyle={{ zIndex: 1 }}
                      open={openPref}
                      placement='bottomRight'
                      trigger={["hover"]}
                      onOpenChange={setOpenPref}
                      dropdownRender={() => prefItemsRender()}
                    >
                      <SwapIcon className={styles.jobTabIcon} />
                    </Dropdown>
                  </>
                ) : (
                  <span className={styles.jobTabNoPref} onClick={handleJobPrefModal}>
                    {right_highlight_text}
                    <AddIconBlue />
                  </span>
                )}
              </div>
            )}
          </div>

          {loading ? (
            <div className={styles.jobTabLoading}>
              <Loading />
            </div>
          ) : (
            <>
              {jobs?.length > 0 ? (
                <>
                  <CardList
                    key={cardType}
                    dictionary={props?.dictionary}
                    jobs={jobs || []}
                    id={type}
                    sessionid={sessionid}
                    cardType={cardType}
                  />
                  <LinkMoreClient moreText={more_text} langKey={langKey} />
                </>
              ) : (
                emptyCustom()
              )}
            </>
          )}
        </div>
      </section>

      {showPrefModal && (
        <JobPrefForHomeModal
          type='add'
          lang={lang}
          open={showPrefModal}
          job_preferences={jobPreferences}
          onClose={() => {
            setLoading(false);
            setShowPrefModal(false);
          }}
          onFinish={(value: any, data) => {
            // console.log("onFinish", { value, data });
            setLoading(false);
            setShowPrefModal(false);
            data?.id && fetchHomePageData(data?.id);
          }}
        />
      )}
    </>
  );
};

export default JobsHiringPc;

const ArrowIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={12} height={12} fill='none' {...props}>
    <path
      stroke='#4B4C4D'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='m3.5 8.5 5-5m0 0h-5m5 0v5'
    />
  </svg>
);

const SwapIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={18} height={18} fill='none' {...props}>
    <path
      fill='#1C70EE'
      fillRule='evenodd'
      d='m16.015 5.205-3.11-3.11-1.06 1.06 2.47 2.47H1.874v1.5h13.344c1.003 0 1.505-1.212.796-1.92Zm-14.03 7.59 3.11 3.11 1.06-1.06-2.47-2.47h12.44v-1.5H2.78c-1.002 0-1.504 1.212-.795 1.92Z'
      clipRule='evenodd'
    />
  </svg>
);

const AddIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={14} height={14} fill='none' {...props}>
    <path
      fill='#000'
      d='M7.583 2.333a.583.583 0 1 0-1.166 0v4.084H2.333a.583.583 0 1 0 0 1.166h4.084v4.084a.583.583 0 0 0 1.166 0V7.583h4.084a.583.583 0 0 0 0-1.166H7.583V2.333Z'
    />
  </svg>
);

const AddIconBlue = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={18} height={18} fill='none' {...props}>
    <path
      fill='#1C70EE'
      d='M9.75 3a.75.75 0 0 0-1.5 0v5.25H3a.75.75 0 1 0 0 1.5h5.25V15a.75.75 0 0 0 1.5 0V9.75H15a.75.75 0 0 0 0-1.5H9.75V3Z'
    />
  </svg>
);

const CheckIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={14} height={14} fill='none' {...props}>
    <path
      fill='#1C70EE'
      fillRule='evenodd'
      d='m12.49 3.453-6.37 7.142a.583.583 0 0 1-.858.012L1.509 6.641l.847-.802 3.317 3.505 5.947-6.668.87.777Z'
      clipRule='evenodd'
    />
  </svg>
);
